import { Booking } from '../../models/booking.model';
import { DEFAULT_CONDITIONS } from '../../models/asset.model';
import { calendarDaysUntilEvent } from '../booking/formalization-deadline.utils';

/** Whole calendar days (Europe/Madrid) from today to the event date. */
export function daysUntilEvent(eventDateIso: string, referenceMs = Date.now()): number {
  return calendarDaysUntilEvent(eventDateIso, referenceMs);
}

export function isWithdrawalEligible(
  booking: Pick<Booking, 'status' | 'date'>,
  cancellationDays: number = DEFAULT_CONDITIONS.cancellationDays,
  referenceMs = Date.now(),
): boolean {
  if (booking.status !== 'CONFIRMED') return false;
  return daysUntilEvent(booking.date, referenceMs) >= cancellationDays;
}
